module.exports = __webpack_public_path__ + "static/media/img-destaque-home.acf2dd78.jpg";